<template>
  <div class="home">
    <my-header activeNum="3" panoNum="1" userNum="1"></my-header>
    <div class="main">
      <div class="page">
        <div class="page-left">
          <div
            :class="{ 'page-left-li': true, active: id == '1' }"
            @click="changeid('1')"
          >
            全景图片
          </div>
          <div
            :class="{ 'page-left-li': true, active: id == '2' }"
            @click="changeid('2')"
          >
            全景视频
          </div>
          <div
            :class="{ 'page-left-li': true, active: id == '4' }"
            @click="changeid('4')"
          >
            图片
          </div>
          <div
            :class="{ 'page-left-li': true, active: id == '3' }"
            @click="changeid('3')"
          >
            模型
          </div>
          <div
            :class="{ 'page-left-li': true, active: id == '6' }"
            @click="changeid('6')"
          >
            视频
          </div>
          <div
            :class="{ 'page-left-li': true, active: id == '7' }"
            @click="changeid('7')"
          >
            音频
          </div>
          <div class="line"></div>
          <!-- <div class>
            <div class>
              <span>空间容量</span>
              <div class="">
                <svg width="16" height="16">
                  <g fill="#000" fill-rule="nonzero">
                    <path
                      d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 12.813A5.813 5.813 0 018 2.187a5.813 5.813 0 010 11.626z"
                    />
                    <path
                      d="M9.744 4.948A2.634 2.634 0 008 4.312c-.656 0-1.275.227-1.744.636-.487.427-.756 1-.756 1.614v.12c0 .068.056.124.125.124h.75a.125.125 0 00.125-.125v-.119c0-.689.673-1.25 1.5-1.25s1.5.561 1.5 1.25c0 .486-.344.932-.877 1.136a1.746 1.746 0 00-1.125 1.654v.335c0 .07.057.126.125.126h.75a.125.125 0 00.125-.126v-.354c0-.308.194-.59.483-.7.922-.355 1.517-1.167 1.517-2.07.002-.615-.267-1.188-.754-1.615zM7.375 11.438a.625.625 0 101.25 0 .625.625 0 00-1.25 0z"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div>0.00B / 3GB</div>
          </div>
          <div class="line"></div> -->
          <div class="word">
            <p>支持 2:1 图片上传</p>
            <p>2:1 最大支持 120MB 以内的全景图片</p>
          </div>
        </div>
        <div class="page-right">
          <div class="">
            <div class="pano-header">
              <div class="select">
                <el-input
                  placeholder="请输入内容"
                  v-model="searchTxt"
                  class="input-with-select"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="search"
                  ></el-button>
                </el-input>
              </div>
              <div class="btnBox" style="margin-right:10px" v-show="id != 3">
                <el-button type="small" @click="transferFolderClick" :disabled="chooseArr.length==0">移动到</el-button>
                <el-button type="small" @click="createFolder">新建文件夹</el-button>
              </div>
              <div>
                <a
                  @click="del"
                  :class="{
                    'pano-button': true,
                    'pano-button-sm': true,
                    'pano-button-primary': true,
                    'pano-button-disabled': isdisable,
                    active: !isdisable,
                  }"
                  style="margin-right: 10px"
                  >删除</a
                >
              </div>
              <div class="upload-block">
                <upload :folderID="nowFolderID" :type="id" :func="uploadPic" v-if="id != 3"></upload>
                <el-button
                  size="mini"
                  @click="
                    dialogFormVisible = true;
                    ID = '';
                    name1 = '';
                    modelpath = '';
                    src1 = './images/model1.png';
                    src2 = './images/noImg.jpg';
                    types = '';
                  "
                  v-if="id == 3"
                  >上传素材</el-button
                >
              </div>
              <el-dialog title="模型信息" :visible.sync="dialogFormVisible">
                <el-form>
                  <el-form-item label="名称" :label-width="width">
                    <el-input
                      v-model="name1"
                      autocomplete="off"
                      style="width: 90%"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="备注" :label-width="width">
                    <el-input
                      v-model="beizhu"
                      autocomplete="off"
                      style="width: 90%"
                    ></el-input>
                  </el-form-item>
                  <div>
                    <el-button accept="image/*" size="mini" @click="upload2"
                      >上传缩略图</el-button
                    >
                    <img
                      :src="src2"
                      height="200"
                      alt=""
                      style="margin-left: 20px"
                    />
                  </div>
                  <div style="margin-top: 20px">
                    <el-button size="mini" @click="upload1" accept=".zip,.rar"
                      >上传模型文件</el-button
                    >
                    <el-input
                      v-model="modelpath"
                      autocomplete="off"
                      style="width: 70%; margin-left: 10px"
                      disabled
                    ></el-input>
                  </div>
                  <el-form-item
                    label="模型类型"
                    :label-width="width"
                    style="margin-top: 20px"
                  >
                    <el-select v-model="types" placeholder="请选择模型类型">
                      <el-option label="obj" value="obj"></el-option>
                      <el-option label="fbx" value="fbx"></el-option>
                      <el-option label="gltf" value="gltf"></el-option>
                      <el-option label="dae" value="dae"></el-option>
                      <el-option label="json" value="json"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogFormVisible = false"
                    >取 消</el-button
                  >
                  <el-button type="primary" @click="confirm">确 定</el-button>
                </div>
              </el-dialog>
            </div>
            <div class="pano-modal-body">
              <!-- <div class="title-line">
                <div class="title-line-left" @click="chooseAll">
                  <div class="checkbox-block">
                    <div :class="{ checkbox: true, active: allcheck }">
                      <i class="el-icon-check"></i>
                    </div>
                  </div>
                  <div>全选</div>
                </div>
              </div> -->
              <div class="list-header" v-show="id != 3">
                <div class="rootFolder" @click="backTop">
                  根目录
                </div>
                <div v-show="nowFolderName!='根目录'">
                  <span class="backFolder" @click="backFolder">返回上一级</span> <span>></span> <span v-html="nowFolderName"></span>
                </div>
              </div>
              <div class="list">
                <div class="list-li list-folder" v-for="(item) in folderArr" :key="item.id">
                  <div class="imgBox" @click="changeFolder(item)">
                    <img src="data:image/png;base64,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">
                  </div>
                  <div class="middle">
                    <div class="li-title">
                      <span class="li-title-span">{{item.name}}</span>
                    </div>
                  </div>
                  <div class="date" style="margin-right: 10px">
                    {{ item.createTime | dateFormat("YY-mm-dd HH:MM") }}
                  </div>
                  <el-button
                    size="mini"
                    @click="rename(item.id)"
                    >重命名</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteFolder(item.id)"
                    >删除</el-button
                  >
                </div>
                <div
                  class="list-li"
                  v-if="id == 1 || id == 2 || id == 4 || id == 6"
                  v-for="(item, i) in arr"
                  :key="i"
                >
                  <div class="checkbox-block" @click="choose(item.id)">
                    <div :class="{ checkbox: true, active: item.check }">
                      <i class="el-icon-check"></i>
                    </div>
                  </div>
                  <div class="middle">
                    <div class="img-block">
                      <img :src="item.thumbnailUrl" />
                    </div>
                    <div class="li-title">{{ item.fileName }}</div>
                  </div>
                  <div class="date" style="margin-right: 10px">
                    {{ item.createTime | dateFormat("YY-mm-dd HH:MM") }}
                  </div>
                  <el-button
                    size="mini"
                    @click="handleEdit(item.id, item.fileName)"
                    >重命名</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(item.id)"
                    >删除</el-button
                  >
                </div>
                <div class="list-li" v-for="(item, i) in arr" v-if="id == 7">
                  <div class="checkbox-block" @click="choose(item.id)">
                    <div :class="{ checkbox: true, active: item.check }">
                      <i class="el-icon-check"></i>
                    </div>
                  </div>
                  <div class="middle">
                    <div class="img-block" @click="playOrPause(i)">
                      <img :src="index == i && isplay == true ? src4 : src3" />
                    </div>
                    <audio
                      style="display: none"
                      loop
                      ref="aud"
                      :src="item.filePath"
                    ></audio>
                    <div class="li-title">{{ item.fileName }}</div>
                  </div>
                  <div class="date" style="margin-right: 10px">
                    {{ item.createTime | dateFormat("YY-mm-dd HH:MM") }}
                  </div>

                  <el-button
                    size="mini"
                    @click="handleEdit(item.id, item.fileName)"
                    >重命名</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(item.id)"
                    >删除</el-button
                  >
                </div>
                <div
                  class="list-li"
                  v-for="(item, i) in arr"
                  :key="i"
                  v-if="id == 3"
                >
                  <div class="checkbox-block" @click="choose(item.id)">
                    <div :class="{ checkbox: true, active: item.check }">
                      <i class="el-icon-check"></i>
                    </div>
                  </div>
                  <div class="middle">
                    <div class="img-block">
                      <img :src="item.icon" />
                    </div>
                    <div class="li-title">{{ item.name }}</div>
                  </div>
                  <div class="date" style="margin-right: 10px">
                    {{ item.createTime | dateFormat("YY-mm-dd HH:MM") }}
                  </div>

                  <el-button size="mini" @click="handleEdit1(item)"
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete1(item.id)"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="page-block">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="page.currentPage"
                  layout="total, prev, pager, next, jumper"
                  :total="page.total"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <input type="file" ref="inputUp1" @change="change1" style="display: none" />
    <input type="file" ref="inputUp2" @change="change2" style="display: none" />
    <el-dialog
        title="移动到文件夹"
        :visible.sync="transferFolder"
        width="800px"
        >
         <div class="list-header">
              <div class="rootFolder" @click="backTopIn">
                根目录
              </div>
              <div v-show="nowFolderNameInner!='根目录'">
                <span class="backFolder" @click="backREInner()">返回上一级</span> <span>></span> <span v-html="nowFolderNameInner"></span>
              </div>
            </div>
             <div class="listIn">
              <div class="list-li list-folder" v-for="(item) in folderArrInner" :key="item.id">
                <div class="imgBox" @click="changeFolderInner(item)">
                  <img src="data:image/png;base64,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">
                </div>
                <div class="middle">
                  <div class="li-title">
                    <span class="li-title-span">{{item.name}}</span>
                  </div>
                  <div style="margin-left:20px" class="date">{{item.createTime | dateFormat('YY-mm-dd HH:MM')}}</div>
                </div>
              </div>
             </div>
             <div class="page-block">
                <el-pagination
                  @current-change="handleCurrentInChange"
                  :current-page="folderPage.currentPage"
                  layout="total, prev, pager, next, jumper"
                  :total="folderPage.total"
                ></el-pagination>
              </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="transferFolderFun">移动到{{nowFolderNameInner}}</el-button>
        </span>
      </el-dialog>
    <my-footer></my-footer>
  </div>
</template>
<style scoped>
.el-form-item__label {
  text-align: left !important;
}
img {
  vertical-align: top;
}
.ListLayout_header_LEhgP5 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30px;
  flex: 0 0 30px;
  margin-bottom: 20px;
}
.block-align-center {
  -webkit-align-items: center;
  -webkit-box-pack: center;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  justify-content: space-between;
}
.home {
  min-width: 1180px;
  background-color: #f8f8f8;
}
.main {
  position: relative;
  margin: 20px auto;
  width: 1180px;
  min-height: calc(100vh - 130px);
}

.page {
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 130px);
}

.page-left {
  position: relative;
  width: 210px;
}

.page-left-li {
  height: 40px;
  padding-left: 20px;
  line-height: 40px;
  color: rgb(95, 95, 95);
  cursor: pointer;
  background-color: transparent;
  border-radius: 5px;
}
.page-left-li.active {
  color: rgb(255, 255, 255);
  background-color: rgb(40, 110, 250);
}
.line {
  height: 1px;
  background-color: rgb(222, 222, 222);
  margin-top: 20px;
  margin-bottom: 20px;
}
.word {
  font-size: 12px;
  color: rgb(122, 122, 122);
  line-height: 17px;
}

.page-right {
  position: relative;
  width: 950px;
  min-height: calc(100vh - 130px);
  background-color: white;
}
.my-dialog.el-dialog--center .el-dialog__body {
  padding: 0 0 10px 0;
}

.my-dialog .el-dialog__header {
  /* padding: 0; */
}

.my-dialog .el-dialog__headerbtn {
  top: 7px;
  right: 7px;
  z-index: 10;
}
</style>
<style scoped>
.el-form-item__label {
  text-align: left !important;
}
.pano-button-disabled,
.pano-button-disabled:hover {
  background-color: #d8d8d8;
  color: #fff;
  border: 1px solid #d8d8d8;
  cursor: not-allowed;
}
.pano-button-sm.active {
  background: #286efa;
  color: white;
}
.pano-button-sm {
  height: 30px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 30px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  margin-right: 10px;
  font-size: 14px;
}
.pano-header {
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 20px;
  font-size: 20px;
  border-bottom: 1px solid #e9e9e9;
}

.title {
  margin-right: 20px;
  font-size: 16px;
  font-weight: 700;
}

.select {
  flex: 1 auto;
}

.input-with-select {
  width: 200px;
}

.upload-block {
  font-size: 14px;
}

.pano-model-body {
  position: relative;
  flex: 1 auto;
}

.title-line {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  background-color: #f3f3f3;
  border-bottom: 1px solid #e9e9e9;
}

.title-line-left {
  display: flex;
  align-items: center;
}

.checkbox-block {
  margin-right: 10px;
}

.checkbox {
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  color: white;
}

.checkbox.active {
  background-color: #427afb;
  border-color: #427afb;
}

.list {
  height: 525px;
}

.list-li {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid #e9e9e9;
}

.middle {
  display: flex;
  flex: 1 auto;
  align-items: center;
}

.img-block {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.img-block img {
  width: 100%;
  height: 100%;
}

.li-title {
  max-width: 500px;

  margin-left: 10px;
  line-height: 30px;
  font-size: 12px;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
}

.date {
  font-size: 12px;
  color: #9b9b9b;
}

.page-block {
  display: flex;
  justify-content: center;
}
.list-header {
  height: 50px;
  width: 100%;
  background-color: #f8f8f8;
  display: flex;
}
.list-header div{
  height: 50px;
  line-height: 50px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.list-header .rootFolder:hover{
  color: #286efa;
}
.list-header .backFolder:hover{
  color: #286efa;
}
.list-folder .imgBox{
  margin-left: 24px;
}
.listIn .list-folder .imgBox{
  margin-left: 0;
}
.img-block {
  width: 40px;
  height: 40px;
  background-color: #ddd;
  cursor: pointer;
}
.imgBox{
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.imgBox img{
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.img-block img {
  width: 100%;
  height: 100%;
}
.btns {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.rename {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  color: #286efa;
  font-size: 12px;
  line-height: 24px;
  text-decoration: none;
}
.del {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  color: #286efa;
  font-size: 12px;
  line-height: 24px;
}
.listIn .list-folder{
  padding-left: 20px;
}
.listIn .list-folder .imgBox{
  margin-left: 0;
}
</style>
<style >
.el-form-item__label {
  text-align: left !important;
}
.el-dialog__footer {
  text-align: center !important;
}
</style>
<script>
import MyHeader from '../components/header.vue'
import MyFooter from '../components/footer.vue'
import upload from '../components/upload.vue'
import https from '../https.js'
import axios from 'axios'
import md5 from 'js-md5'
export default {
  name: '',
  components: {
    MyHeader: MyHeader,
    MyFooter: MyFooter,
    upload: upload
  },
  data() {
    return {
      id: '1',
      searchTxt: '',
      width: '400',
      allcheck: false,
      page: {
        currentPage: 1,
        total: 0
      },
      dialog: true,
      index: -1,
      src1: './images/model1.png',
      src2: './images/noImg.jpg',
      src3: './images/play1.png',
      src4: './images/pause1.png',
      modelpath: '',
      dialogFormVisible: false,
      arr: [],
      isdisable: true,
      chooseArr: [],
      types: '',
      name1: '',
      beizhu: '',
      ID: '',
      isplay: false,
      nowFolderName: '根目录',
      nowFolderID: '',
      nowFolderPName: '',
      nowFolderPID: '',
      fileArr: [],
      folderCurrentPage: 1,
      folderArrInner: [],
      nowFolderIDInner: '',
      nowFolderPIDInner: '',
      nowFolderPNameInner: '',
      folderPage: {
        currentPage: 1,
        total: 0
      },
      nowFolderNameInner: '根目录',
      transferFolder: false,
      hasChooseFile: true,
      folderArr: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    backTopIn() {
      this.nowFolderNameInner = '根目录'
      this.nowFolderIDInner = ''
      this.nowFolderPNameInner = ''
      this.nowFolderPIDInner = ''
      https
        .fetchGet('/api/folder/Get', {
          folderType: this.genFolderType(),
          pageIndex: this.folderPage.currentPage,
          pageSize: 10,
          id: this.nowFolderIDInner
        })
        .then(res => {
          console.log(res.data)
          this.folderPage.total = res.data.count
          this.folderArrInner = res.data.result
          this.transferFolder = true
        })
    },
    backTop() {
      this.nowFolderName = '根目录'
      this.nowFolderID = ''
      if (this.id != 3) {
        this.init()
      } else {
        this.init1()
      }
    },
    backFolder() {
      if(this.nowFolderPID == null) {
        this.nowFolderID = ''
        this.nowFolderName = '根目录'
        if (this.id != 3) {
          this.init()
        } else {
          this.init1()
        }
      }else{
        https
          .fetchGet('/api/folder/Get', {
            FID: this.nowFolderPID
          })
          .then(res => {
            console.log(res.data)
            this.nowFolderName = res.data.result[0].name
            this.nowFolderID = res.data.result[0].id
            this.nowFolderPID = res.data.result[0].parentID
            if (this.id != 3) {
              this.init()
            } else {
              this.init1()
            }
          })
      }
    },
    backREInner() {
      if(this.nowFolderPIDInner == null) {
        this.nowFolderIDInner = ''
        this.nowFolderNameInner = '根目录'
        https
          .fetchGet('/api/folder/Get', {
            folderType: this.genFolderType(),
            pageIndex: this.folderPage.currentPage,
            pageSize: 10,
            id: this.nowFolderPIDInner
          })
          .then(res => {
            console.log(res.data)
            this.folderPage.total = res.data.count
            this.folderArrInner = res.data.result
            this.transferFolder = true
          })
      }else{
        https
          .fetchGet('/api/folder/Get', {
            FID: this.nowFolderPIDInner
          })
          .then(res => {
            console.log(res.data)
            this.nowFolderNameInner = res.data.result[0].name
            this.nowFolderIDInner = res.data.result[0].id
            this.nowFolderPIDInner = res.data.result[0].parentID
            https
              .fetchGet('/api/folder/Get', {
                folderType: this.genFolderType(),
                pageIndex: this.folderPage.currentPage,
                pageSize: 10,
                id: this.nowFolderIDInner
              })
              .then(res => {
                console.log(res.data)
                this.folderPage.total = res.data.count
                this.folderArrInner = res.data.result
                this.transferFolder = true
              })
          })
      }
    },
    transferFolderClick() {
      this.nowFolderIDInner = ''
      this.nowFolderNameInner = '根目录'
      https
        .fetchGet('/api/folder/Get', {
          folderType: this.genFolderType(),
          pageIndex: this.folderPage.currentPage,
          pageSize: 10,
          id: this.nowFolderIDInner
        })
        .then(res => {
          console.log(res.data)
          this.folderPage.total = res.data.count
          this.folderArrInner = res.data.result
          this.transferFolder = true
        })
    },
    handleClose() {
    },
    changeFolderInner(item) {
      this.nowFolderPNameInner = this.nowFolderNameInner
      this.nowFolderIDInner = item.id
      this.nowFolderNameInner = item.name
      this.nowFolderPIDInner = item.parentID
      https
        .fetchGet('/api/folder/Get', {
          folderType: this.genFolderType(),
          pageIndex: this.folderPage.currentPage,
          pageSize: 10,
          id: this.nowFolderIDInner
        })
        .then(res => {
          console.log(res.data)
          this.folderPage.total = res.data.count
          this.folderArrInner = res.data.result
        })
    },
    changeFolder(item) {
      this.nowFolderPName = this.nowFolderName
      this.nowFolderID = item.id
      this.nowFolderName = item.name
      this.nowFolderPID = item.parentID
      if (this.id != 3) {
        this.init()
      } else {
        this.init1()
      }
    },
    transferFolderFun() {
      console.log(this.chooseArr)
      for (let index = 0; index < this.chooseArr.length; index++) {
        const element = this.chooseArr[index]
        this.fileArr.push(element.id)
      }
      console.log(this.fileArr)
      https
        .fetchGet('/api/folder/MoveToFolder_File', {
          sceneID: this.fileArr.join(','),
          folderID: this.nowFolderIDInner === '' ? '00000000-0000-0000-0000-000000000000' : this.nowFolderIDInner
        })
        .then(res => {
          console.log(res.data)
          if(res.data.code === 1) {
            this.$message({
              type: 'info',
              message: '移动成功'
            })
          }else{
            this.$message({
              type: 'info',
              message: '移动失败'
            })
          }
          this.fileArr = []
          this.chooseArr = []
          this.isdisable = true
          this.transferFolder = false
          if (this.id != 3) {
            this.init()
          } else {
            this.init1()
          }
        })
    },
    changeFileArr(mJson) {
      if(mJson.checked) {
        this.fileArr.push(mJson.id)
      }else{
        var index = this.fileArr.indexOf(mJson.id)
        if (index > -1) {
          this.fileArr.splice(index, 1)
        }
      }
    },
    rename(id) {
      this.$prompt('请输入文件夹名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        https.fetchPost('/api/folder/Edit', {
          id: id,
          name: value,
          parentID: this.nowFolderID,
          type: 1 //1：全景图片作品 2：全景视频品 3:全景图片素材 4：全景视频素材 5：图片素材 6：模型素材 7：视频素材 8：音频素材
        })
          .then(res => {
            console.log(res)
            if (this.id != 3) {
              this.init()
            } else {
              this.init1()
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    deleteFolder(id) {
      this.$confirm('确定删除文件内所有内容，本操作无法恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        https.fetchPost('/api/folder/Edit', {
          id: id,
          status: 0
        })
          .then(res => {
            console.log(res)
            this.$message({
              type: 'info',
              message: '删除成功'
            })
            if (this.id != 3) {
              this.init()
            } else {
              this.init1()
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    createFolder() {
      this.$prompt('请输入文件夹名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        https.fetchPost('/api/folder/Edit', {
          name: value,
          parentID: this.nowFolderID,
          folderType: this.genFolderType() //1：全景图片作品 2：全景视频品 3:全景图片素材 4：全景视频素材 5：图片素材 6：模型素材 7：视频素材 8：音频素材
        })
          .then(res => {
            console.log(res)
            if (this.id != 3) {
              this.init()
            } else {
              this.init1()
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    playOrPause(i) {
      for (var j = 0; j < this.$refs.aud.length; j++) {
        this.$refs.aud[j].pause()
      }
      if (i == this.index) {
        this.isplay = !this.isplay
      } else {
        this.isplay = true
      }
      this.index = i
      if (this.isplay == true) {
        this.$refs.aud[i].play()
      } else {
        this.$refs.aud[i].pause()
      }
      console.log(i)
    },
    confirm() {
      if (this.name1 == '') {
        this.$message({
          type: 'error',
          message: '名称不能为空!',
          duration: 1000
        })
      } else if (this.modelpath == '') {
        this.$message({
          type: 'error',
          message: '模型不能为空!',
          duration: 1000
        })
      } else if (this.types == '') {
        this.$message({
          type: 'error',
          message: '请选择模型类型!',
          duration: 1000
        })
      } else {
        if (this.ID == '') {
          https
            .fetchPost('/api/model/AddScene', {
              id: '',
              name: this.name1,
              remark: this.beizhu,
              path: this.modelpath,
              icon: this.src2,
              sceneType: this.types
            })
            .then((res) => {
              this.$message({
                type: 'success',
                message: '添加成功!',
                duration: 1000
              })
              this.dialogFormVisible = false
              this.init1()
              this.name1 = ''
              this.beizhu = ''
              this.type = ''
              this.src1 = './images/model1.png'
              this.src2 = './images/noImg.jpg'
              this.modelpath = ''
            })
        } else {
          https
            .fetchPost('/api/model/UpdateScene', {
              id: this.ID,
              name: this.name1,
              remark: this.beizhu,
              path: this.modelpath,
              icon: this.src2,
              sceneType: this.types
            })
            .then((res) => {
              this.$message({
                type: 'success',
                message: '添加成功!',
                duration: 1000
              })
              this.dialogFormVisible = false
              this.init1()
              this.name1 = ''
              this.beizhu = ''
              this.type = ''
              this.src1 = './images/model1.png'
              this.src2 = './images/noImg.jpg'
              this.modelpath = ''
            })
        }
      }
    },
    upload1() {
      this.$refs.inputUp1.click()
    },
    upload2() {
      this.$refs.inputUp2.click()
    },
    uploadPic() {
      this.init()
    },
    suolue(id) {
      // this.$refs.inputUp1.click();
    },
    change1(e) {
      var files = e.target.files
      var file = files[0]
      const fileReader = new FileReader()
      const blobSlice =
        File.prototype.mozSlice ||
        File.prototype.webkitSlice ||
        File.prototype.slice
      const chunkSize = 2097152
      // read in chunks of 2MB
      const chunks = Math.ceil(file.size / chunkSize)
      let currentChunk = 0

      let bir = ''
      const a = this
      const formData = new FormData()
      // formData.append('type', 2)
      formData.append('hashvalue', md5(bir))
      formData.append('file', file)
      fileReader.onload = function (e) {
        console.log('read chunk nr', currentChunk + 1, 'of', chunks)
        bir += e.target.result // append binary string
        currentChunk++
        if (currentChunk < chunks) {
          loadNext()
        } else {
          console.log(md5(bir))

          console.log(formData.get('hashvalue'))
          var options = {
            // 设置axios的参数
            url: '/api/model/UploadModel',
            data: formData,
            method: 'post',
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          axios(options).then((res) => {
            console.log(res)
            if (res.data.mes === '成功') {
              a.src1 = './images/model2.png'
              a.modelpath = 'http://model001.z2ww.com' + res.data.filePath

              a.$message({
                type: 'success',
                message: '上传成功!',
                duration: 1000
              })
            }
          })
        }
      }
      function loadNext() {
        var start = currentChunk * chunkSize
        var end =
          start + chunkSize >= file.size ? file.size : start + chunkSize
        fileReader.readAsBinaryString(blobSlice.call(file, start, end))
      }
      loadNext()
    },
    change2(e) {
      var files = e.target.files
      var file = files[0]
      const fileReader = new FileReader()
      const blobSlice =
        File.prototype.mozSlice ||
        File.prototype.webkitSlice ||
        File.prototype.slice
      const chunkSize = 2097152
      // read in chunks of 2MB
      const chunks = Math.ceil(file.size / chunkSize)
      let currentChunk = 0

      let bir = ''
      const a = this
      const formData = new FormData()
      // formData.append('type', 2)
      formData.append('hashvalue', md5(bir))
      formData.append('file', file)
      fileReader.onload = function (e) {
        console.log('read chunk nr', currentChunk + 1, 'of', chunks)
        bir += e.target.result // append binary string
        currentChunk++
        if (currentChunk < chunks) {
          loadNext()
        } else {
          console.log(md5(bir))

          console.log(formData.get('hashvalue'))
          var options = {
            // 设置axios的参数
            url: '/api/model/UploadModel',
            data: formData,
            method: 'post',
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          axios(options).then((res) => {
            console.log(res)
            if (res.data.mes === '成功') {
              a.src2 = 'http://model001.z2ww.com' + res.data.filePath

              a.$message({
                type: 'success',
                message: '上传成功!',
                duration: 1000
              })
            }
          })
        }
      }
      function loadNext() {
        var start = currentChunk * chunkSize
        var end =
          start + chunkSize >= file.size ? file.size : start + chunkSize
        fileReader.readAsBinaryString(blobSlice.call(file, start, end))
      }
      loadNext()
    },
    del() {
      var a = this
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (a.id != 3) {
            var ids = []
            for (var i = 0; i < a.chooseArr.length; i++) {
              var item = { id: a.chooseArr[i].id, status: 0 }
              ids.push(item)
            }
            https
              .fetchPost('/api/PhysicalFile/BatchEdit', { list: ids })
              .then((res) => {
                if (res.data.code == 0) {
                  var str = ''
                  for (var i = 0; i < res.data.list.length; i++) {
                    if (i < res.data.list.length - 1) {
                      str += res.data.list[i].fileName + ','
                    } else {
                      str += res.data.list[i].fileName
                    }
                  }
                  a.$message({
                    type: 'error',
                    message: '删除失败!' + str + '已关联',
                    duration: 1000
                  })
                } else {
                  a.$message({
                    type: 'success',
                    message: '删除成功!',
                    duration: 1000
                  })
                }
                a.init()
                ids = []
              })
          } else {
            var ids = []
            for (var i = 0; i < a.chooseArr.length; i++) {
              var item = { id: a.chooseArr[i].id }
              ids.push(item)
            }
            https
              .fetchPost('/api/model/DeleteScenes', { scenes: ids })
              .then((res) => {
                if (res.data.code == 1) {
                  a.$message({
                    type: 'success',
                    message: '删除成功!',
                    duration: 1000
                  })
                } else {
                  a.$message({
                    type: 'error',
                    message: '删除失败!',
                    duration: 1000
                  })
                }
                a.init1()
                ids = []
              })
          }
        })
        .catch(() => {
          a.$message({
            type: 'info',
            message: '已取消删除',
            duration: 1000
          })
        })
    },
    search() {
      this.init()
    },
    handleEdit(id, name) {
      this.$prompt('请输入名字', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '名字不能为空',
        inputValue: name
      })
        .then(({ value }) => {
          https
            .fetchPost('/api/PhysicalFile/Edit', {
              id: id,
              fileName: value
            })
            .then((res) => {
              this.$message({
                type: 'success',
                message: '修改成功!',
                duration: 1000
              })
              this.init()
            })
        })
        .catch(() => {})
    },
    handleDelete1(id) {
      var a = this
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          https
            .fetchGet('/api/model/DeleteScene', {
              id: id
            })
            .then((res) => {
              a.$message({
                type: 'success',
                message: '删除成功!',
                duration: 1000
              })
              a.init1()
            })
        })
        .catch(() => {})
    },
    handleEdit1(item) {
      this.dialogFormVisible = true
      this.name1 = item.name
      this.beizhu = item.remark
      this.types = item.sceneType
      this.ID = item.id
      this.modelpath = item.path
      if (item.path != '') {
        this.src1 = './images/model2.png'
      } else {
        this.src1 = './images/model1.png'
      }
      if (item.icon != '') {
        this.src2 = item.icon
      } else {
        this.src2 = './images/noImg.jpg'
      }
    },
    handleDelete(id) {
      var IDS = []
      IDS.push({ id: id, status: 0 })
      var a = this
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          https
            .fetchPost('/api/PhysicalFile/BatchEdit', { list: IDS })
            .then((res) => {
              if (res.data.code == 0) {
                var str = ''
                for (var i = 0; i < res.data.list.length; i++) {
                  if (i < res.data.list.length - 1) {
                    str += res.data.list[i].fileName + ','
                  } else {
                    str += res.data.list[i].fileName
                  }
                }
                a.$message({
                  type: 'error',
                  message: '删除失败!' + str + '已关联',
                  duration: 1000
                })
              } else {
                a.$message({
                  type: 'success',
                  message: '删除成功!',
                  duration: 1000
                })
              }
              a.init()
              IDS = []
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
            duration: 1000
          })
        })
    },
    chooseAll() {
      this.allcheck = !this.allcheck
      if (this.allcheck) {
        for (let i = 0; i < this.arr.length; i++) {
          this.arr[i].check = true
        }
        this.chooseArr = this.arr
      } else {
        for (let i = 0; i < this.arr.length; i++) {
          this.arr[i].check = false
        }
        this.chooseArr = []
      }
      if (this.chooseArr.length > 0) {
        this.isdisable = false
      } else {
        this.isdisable = true
      }
    },
    choose(id) {
      this.chooseArr = []
      for (let i = 0; i < this.arr.length; i++) {
        if (this.arr[i].id == id) {
          const isCheck = this.arr[i].check || false
          if (isCheck) {
            this.arr[i].check = false
          } else {
            console.log(isCheck)
            this.arr[i].check = true
            console.log(this.arr)
            this.chooseArr.push(this.arr[i])
          }
        } else {
          if (this.arr[i].check) {
            this.chooseArr.push(this.arr[i])
          }
        }
      }
      if (
        this.chooseArr.length == 8 ||
        this.chooseArr.length == this.page.total
      ) {
        this.allcheck = true
      } else {
        this.allcheck = false
      }
      if (this.chooseArr.length > 0) {
        this.isdisable = false
      } else {
        this.isdisable = true
      }
    },
    changeid(id) {
      this.id = id
      this.page.currentPage = 1
      this.nowFolderNameInner = '根目录'
      this.nowFolderIDInner = ''
      this.nowFolderPNameInner = ''
      this.nowFolderPIDInner = ''
      this.nowFolderName = '根目录'
      this.nowFolderPID = ''
      this.nowFolderPName = ''
      this.nowFolderID = ''
      this.chooseArr = []
      this.fileArr = []
      if (this.id != 3) {
        this.init()
      } else {
        this.init1()
      }
    },
    handleCurrentChange(val) {
      if (this.id != 3) {
        this.allcheck = false
        this.chooseArr = []
        this.page.currentPage = val
        this.init()
      } else {
        this.allcheck = false
        this.chooseArr = []
        this.page.currentPage = val
        this.init1()
      }
    },
    handleCurrentInChange(val) {
      this.folderPage.currentPage = val
      https
        .fetchGet('/api/folder/Get', {
          folderType: this.genFolderType(),
          pageIndex: this.folderPage.currentPage,
          pageSize: 10,
          id: this.nowFolderIDInner
        })
        .then(res => {
          this.folderPage.total = res.data.count
          this.folderArrInner = res.data.result
        })
    },
    genFolderType() {
      switch(this.id) {
        case '1':
          return 3
        case '2':
          return 4
        case '3':
          return 6
        case '4':
          return 5
        case '6':
          return 7
        case '7':
          return 8
      }
    },
    init() {
      https
        .fetchPost('/api/PhysicalFile/Get', {
          type: this.id,
          pageIndex: this.page.currentPage,
          fileName: this.searchTxt,
          pageSize: 10,
          folderID: this.nowFolderID,
          folderType: this.genFolderType()
        })
        .then((res) => {
          console.log(res)
          this.page.total = res.data.count
          if(res.data.result != null) {
            for (let i = 0; i < res.data.result.length; i++) {
              res.data.result[i].check = false
            }
          }
          this.arr = res.data.result
          this.folderArr = res.data.folders
          console.log(this.arr)
        })
    },
    init1() {
      https
        .fetchGet('/api/model/GetBaseSceneInfo', {
          pageIndex: this.page.currentPage,
          // fileName:this.searchTxt,
          pageSize: 10
        })
        .then((res) => {
          console.log(res)
          this.page.total = res.data.count

          for (let i = 0; i < res.data.result.length; i++) {
            res.data.result[i].check = false
          }
          this.arr = res.data.result
        })
    }
  }
}
</script>
